export const PRODUCT_TYPES = {
  PRODUCT: 'PRODUCT',
  INDIVIDUAL: 'INDIVIDUAL',
  CATEGORY: 'CATEGORY',
  SHIPPING_COST: 'SHIPPING_COST',
  GIFT_CARD: 'GIFT_CARD',
  TIPS: 'TIPS',
  SERVICE: 'SERVICE',
  DEPOSIT: 'DEPOSIT',
  DEPOSIT_RETURN: 'DEPOSIT_RETURN',
};
